import { useMemo } from 'react';
import { useUpdateDebugModeAccessMutation } from '../api';
export const useUpdateDebugModeAccess = () => {
    const [updateDebugModeAccess, { isLoading, isError, error }] = useUpdateDebugModeAccessMutation();
    return useMemo(() => ({
        updateDebugModeAccess,
        isLoading,
        isError,
        error,
    }), [error, isError, isLoading, updateDebugModeAccess]);
};
